export default {
  pointEntries: null
}
